module.exports = __webpack_public_path__ + "media/images/toggle_off-afc31fd7c253bdef385786abaff39ec3.png";